import axios from 'axios';
import { errorHandler } from './requestFull'
// import * as Sentry from "@sentry/nextjs";

const request = axios.create({
  withCredentials: false,
  timeout: 30000, // Set timeout to 5 seconds
  headers: {
    'Content-Type': 'application/json', // Set content type to JSON
    // 'CF-Access-Client-Id': '586cf5f448d80348bc89a53711b7c749.access',
    // 'CF-Access-Client-Secret': '39a09738c447e51a34f207d2f0991ecbb59a126559445cf8400d4896b6d6dd1e'
  },
});

// Add a response interceptor
request.interceptors.response.use(
  response => {
    // Handle successful responses
    return response.data;
  },
  errorHandler
);

export default request;